import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

import MyTypography from "../MyTypography";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: 420,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16,
        padding: "32px 24px",
        overflow: "auto"
      }
    },
    dialogTitle: {
      padding: 0,
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    },
    mainTitle: {
      color: theme.palette.grey[900]
    },
    dialogCenter: {
      padding: "0px !important",
      margin: "24px 0 32px 0 !important"
    },
    dialogFooter: {
      borderTop: 0,
      padding: 0,
      justifyContent: "space-between",
      gap: 16,
      "& button": {
        width: "100%",
        margin: "0 !important"
      },
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    btnClose: {
      height: "48px"
    },
    confirmBtn: {
      width: "100%",
      height: "42px",
      padding: "0.6rem",
      fontSize: "14px",
      color: "white",
      backgroundColor: "#222",
      "& .MuiButton-label": {
        fontWeight: "700"
      }
    }
  }),
  { name: "DialogConfirmItem" }
);

interface DialogConfirmItemProps {
  title?: string;
  content?: string;
  open: boolean;
  testId?: string;
  onConfirm(): void;
  onClose(): void;
}

const DialogConfirmItem: React.FC<DialogConfirmItemProps> = ({
  title,
  content,
  open,
  testId,
  onConfirm,
  onClose
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      className={classes.root}
      open={open}
      onClose={onClose}
      data-testid={testId ?? "dialogConfirmItem"}
    >
      {title ? (
        <DialogTitle className={classes.dialogTitle}>
          <MyTypography variant="h6" className={classes.mainTitle}>
            {title}
          </MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      {content ? (
        <DialogContent className={classes.dialogCenter}>
          <MyTypography variant="body2">{content}</MyTypography>
        </DialogContent>
      ) : (
        ""
      )}
      <DialogActions className={classes.dialogFooter}>
        <Button
          id="backButton"
          data-testid="backButton"
          variant="outlined"
          color="inherit"
          onClick={onClose}
        >
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "กลับไป" })}
          </MyTypography>
        </Button>
        <Button
          id="confirmButton"
          data-testid="confirmButton"
          variant="contained"
          color="inherit"
          onClick={onConfirm}
          className={classes.confirmBtn}
        >
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "ยืนยัน" })}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmItem;
